export default "__VITE_ASSET__rC0dg9UZ__"